import { ApiFieldForProfileDisplay } from "shared/types/ApiFieldForProfileDisplay";
import ViewProfileReadOnlyField from "../readOnlyField";

export default function ViewProfileOverview(props: { profile?: Array<ApiFieldForProfileDisplay> }) {
  return (
    <div className="form--flex profileOverview">
      {props.profile?.map((o: ApiFieldForProfileDisplay) => (
        <ViewProfileReadOnlyField key={o.id} field={o} />
      ))}
    </div>
  );
}
